/**
 Author - Babajan
Github - https://github.com/babajanpatan
 **/

import NewThankYou from "./NewThankYou.container";

export default NewThankYou;
